import { useRef, useState } from 'react'

export function useDocusignRuntimeState() {
  const [docusignUrl, setDocusignUrl] = useState<string | null>(null)
  const [docusignFrameKey, setDocusignFrameKey] = useState(0)
  const [isDocusignModalOpen, setIsDocusignModalOpen] = useState(false)
  const [signatureStatus, setSignatureStatus] = useState<string | null>(null)
  const [isSignatureSigned, setIsSignatureSigned] = useState(false)
  const [isPreparingDocusign, setIsPreparingDocusign] = useState(false)
  const [isDocusignIframeLoading, setIsDocusignIframeLoading] = useState(false)
  const [isFinalizingDocusign, setIsFinalizingDocusign] = useState(false)
  const [isCheckingSignature, setIsCheckingSignature] = useState(false)
  const hasLoadedDocusignIframeRef = useRef(false)
  const hasBlurredDuringDocusignRef = useRef(false)
  const isRestartingDocusignRef = useRef(false)
  const isPreparingDocusignRef = useRef(false)

  const resetDocusignRuntime = () => {
    setSignatureStatus(null)
    setIsSignatureSigned(false)
    setDocusignUrl(null)
    setIsDocusignModalOpen(false)
  }

  return {
    docusignFrameKey,
    docusignUrl,
    hasBlurredDuringDocusignRef,
    hasLoadedDocusignIframeRef,
    isCheckingSignature,
    isDocusignIframeLoading,
    isDocusignModalOpen,
    isFinalizingDocusign,
    isPreparingDocusign,
    isPreparingDocusignRef,
    isRestartingDocusignRef,
    isSignatureSigned,
    resetDocusignRuntime,
    setDocusignFrameKey,
    setDocusignUrl,
    setIsCheckingSignature,
    setIsDocusignIframeLoading,
    setIsDocusignModalOpen,
    setIsFinalizingDocusign,
    setIsPreparingDocusign,
    setIsSignatureSigned,
    setSignatureStatus,
    signatureStatus
  }
}
